module.exports = __webpack_public_path__ + "img/gearbox_icon.b25a824a.png";